'use strict';
const angular = require('angular');

/*@ngInject*/
export function NewsService($resource) {
  return $resource('/api/news/:id', {
    id: '@_id'
  },{
    getByType: {
      method: 'GET',
      url: "/api/news/type/:type",
      isArray: true
    },
    getByTypeLimitResult: {
      method: 'GET',
      url: "/api/news/type/:type/:count",
      isArray: true
    },
    getFeatured: {
      method: 'GET',
      url: "/api/news/featured",
      isArray: true
    },
    getPublic: {
      method: 'GET',
      url: "/api/news/public",
      isArray: true
    },
    getNewest: {
      method: 'GET',
      url: "/api/news/newest/:count",
      isArray: true
    },
    getNewestByCategories: {
      method: 'GET',
      url: "/api/news/newest/:count/:categories",
      isArray: true
    },
    patch: {
      method: 'PATCH'
    },
    update: {
      method: 'PUT'
    },
    getDigitalSignageFeatured: {
      method: 'GET',
      url: "/api/news/digital-signage-featured",
      isArray: true
    }
  });
}


export default angular.module('conduuApp.NewsService', [])
  .factory('NewsService', NewsService)
  .name;



// WEBPACK FOOTER //
// ./client/services/news/news.service.js